import React, { useState } from "react";

import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import { UpdateProfileApiParameter } from "@dana/Services/DanaMyProfileService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import toggleShowPriceSetting from "@dana/Store/Data/ShowPrice/Handlers/ToggleSettingHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";
// import StyledWrapper from "path-to-your-styled-wrapper"; // Import your styled component


const mapStateToProps = (state: ApplicationStateDana) => ({
    canUserSeePrice: state?.showPriceToggle.canSeePrice,
});

const mapDispatchToProps = {
    toggleShowPriceSetting
};
type SettingSwitchProps = ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface DanaMenuItemStyles {

    settingSwitchWraper?: InjectableCss;
}
export const danaMenuItemStyles: DanaMenuItemStyles = {

    settingSwitchWraper: {
        css: css`
            display: flex;
            align-items: center;
            gap: 24px;

            .switch {
                position: relative;
                display: inline-block;
                width: 50px;
                height: 28px;

                input:checked + .slider {
                    background-color: ${themeColors.primary.danaBlue};
                }

                input:checked + .slider::before {
                    transform: translateX(22px);
                }

                input {
                    opacity: 0;
                    width: 0;
                    height: 0;
                }

                .slider {
                    position: absolute;
                    cursor: pointer;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: ${themeBackgrounds.lightGray};
                    transition: 0.4s;
                    border-radius: 28px;

                    &::before {
                        position: absolute;
                        content: "";
                        height: 22px;
                        width: 22px;
                        left: 3px;
                        bottom: 3px;
                        background-color: ${themeBackgrounds.white};
                        transition: 0.4s;
                        border-radius: 50%;
                    }
                }
            }
        `,
    },
};
const styles = danaMenuItemStyles;
const ShowPriceSettingSwitch: React.FC<SettingSwitchProps> = ({
    canUserSeePrice,
    toggleShowPriceSetting
}) => {
    const [canSeePriceToggle, setCanSeePriceToggle] = useState(canUserSeePrice);

    const callPricingToggle = (isChecked: boolean) => {
        setCanSeePriceToggle(isChecked);
        toggleShowPriceSetting({ canSeePrice: isChecked } as UpdateProfileApiParameter);
    };


    return (
        <StyledWrapper {...styles.settingSwitchWraper}>
            <Typography>{translate("Show Price")}</Typography>
            <label className="switch">
                <input
                    checked={canSeePriceToggle}
                    type="checkbox"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        callPricingToggle(e.target.checked)
                    }
                />
                <span className="slider" />
            </label>
        </StyledWrapper>
    )
};
export default connect(mapStateToProps, mapDispatchToProps)(ShowPriceSettingSwitch);

